import deliverySvg from '@/assets/icons/delivery.svg'

import style from './ProductCard.module.scss'

export default memo(function ProductShippingInfo({value}: {value?: string}) {
  // const shouldDisplayShippingInfo =
  //   [Retailer.Amazon, Retailer.Walmart].includes(retailer) &&
  //   !!program &&
  //   [Program.AmazonPrime, Program.WalmartPlus].includes(program)

  // if (!shouldDisplayShippingInfo) return null

  // const shippingInfoText = value
  //   ? value
  //   : price >= 35
  //     ? 'FREE delivery'
  //     : 'Free delivery on $35 of items'

  if (!value) return null

  return (
    <div className={style.ShippingInfo}>
      <div className={style.Text}>
        <img src={deliverySvg} alt='' />
        {value}
      </div>
      <div className={style.Decoration}></div>
    </div>
  )
})
